<template lang="pug">
.container-fluid.m-0.h-100.py-5
  .row.align-items-center.h-100
    .col-lg-8.offset-lg-2
      .card.p-4.transit-card
        h3.mb-5.text-secondary.text-center {{ $t('signUp.companyTitle') }}
        wizard(@submit="createCompany", @cancel="logOut")
          wizard-step.my-5(
            :title="$t('signUp.steps.company')",
            :cancel-title="$t('navbar.logout')",
          )
            b-form-row
              .col-sm-6
                r-input.sp-input(
                  :label="$t('form.company.siret')",
                  v-model="company.siret",
                  :maxlength="40"
                  type="text"
                  name="companySiret"
                )
              .col-sm-6
                r-input.sp-input(
                  :label="$t('form.company.name')",
                  v-model="company.name",
                  name="companyName"
                )
            b-form-row
              .col-12
                address-auto-complete.sp-input(
                  :label="$t('form.address1')",
                  v-model="company.address.address1",
                  @address="setCompanyAddress",
                  name="companyAddress1"
                )
            b-form-row
              .col-12
                r-input.sp-input(
                  :label="$t('form.address2')",
                  v-model="company.address.address2",
                  name="companyAddress2",
                  :required="false"
                )
            b-form-row
              .col-sm-5.col-lg-6
                r-input.sp-input(
                  :label="$t('form.city')",
                  v-model="company.address.city",
                  name="companyCity"
                )
              .col-sm-3
                r-input.sp-input(
                  :label="$t('form.postalCode')",
                  v-model="company.address.zipCode",
                  name="companyZipCode",
                  type="text",
                  :maxlength="6",
                  :minlength="4",
                  :required="false",
                  @input="formatPostalCode"
                )
              .col-sm-4.col-lg-3
                r-input.sp-input(
                  :label="$t('form.country')",
                  v-model="company.address.country",
                  name="companyCountry"
                )

          wizard-step.my-5(
            :title="$t('signUp.steps.config')",
            :disabled="!enbaleConfig",
            :step-title="$t('signUp.cta.company')"
          )
            b-form-row.mt-4
              .col-12
                CountrySelect.sp-c-select(
                  v-model="company.countryFrom",
                  :label="$t('form.company.countriesFrom')",
                  :multiple="true",
                  css-class="large-select"
                )
            b-form-row.mt-3
              .col-12
                address-auto-complete(:label="$t('form.company.cityFrom')" v-model="addressfrom.city" :value="addressfrom.city" @addresscity="setcityfrom" name="addresscityfrom" :type="'text'" :maxlength="20" :required="false"  )
                div.input-div
                  div.c-animated-background.input-inner-div-1
                  div.c-animated-background.input-inner-div-2
            b-form-row
              .col-12
                CitySelect(v-model="company.citiesFrom" :label="$t('form.company.citiesFrom')"  :multiple="true" @deletecity="deletecityfrom" css-class="large-select" )
                div.input-div
                  div.c-animated-background.input-inner-div-1
                  div.c-animated-background.input-inner-div-3
            b-form-row.mt-4
              .col-12
                CountrySelect.sp-c-select(
                  v-model="company.countryTo",
                  :label="$t('form.company.countriesTo')",
                  :multiple="true",
                  css-class="large-select"
                )
            b-form-row.mt-3
              .col-12
                address-auto-complete(:label="$t('form.company.cityTo')" v-model="addressto.city" :value="addressto.city" @addresscity="setcityto" name="addresscityto" :type="'text'" :maxlength="20" :required="false"  )
                div.input-div
                  div.c-animated-background.input-inner-div-1
                  div.c-animated-background.input-inner-div-2
            b-form-row
              .col-12
                CitySelect(v-model="company.citiesTo" :label="$t('form.company.citiesTo')"  :multiple="true" @deletecity="deletecityto" css-class="large-select" )
                div.input-div
                  div.c-animated-background.input-inner-div-1
                  div.c-animated-background.input-inner-div-3

            b-form-row.mt-4
              .col-12
                .form-group
                  b-form-checkbox(
                    v-model="company.car",
                    :value="true",
                    :unchecked-value="false",
                    name="car"
                  )
                    | {{ $t('form.company.cars') }}
              .col-12
                .form-group
                  b-form-checkbox(
                    v-model="company.packet",
                    :value="true",
                    :unchecked-value="false"
                  )
                    | {{ $t('form.company.parcels') }}
              .col-12
                .form-group
                  b-form-checkbox(
                    v-model="company.container",
                    :value="true",
                    :unchecked-value="false"
                  )
                    | {{ $t('form.company.containers') }}
</template>

<script>
import { Auth } from "aws-amplify";
import { mapState } from "vuex";
import CountrySelect from "@/components/ui/CountrySelect";
import RegionSelect from "@/components/ui/RegionSelect";
import CitySelect from '@/components/ui/CitySelect';
export default {
  name: "CreateCompany",
  components: { CountrySelect,RegionSelect,CitySelect },
  data() {
    return {
      company: {
        name: null,
        siret: null,
        address: {
          address1: null,
          address2: null,
          city: null,
          zipCode: null,
          country: null,
        },
       
        countryTo: [],
        countryFrom: [],
        citiesTo: [],
        citiesFrom: [],
        car: false,
        packet: false,
        container:false,
      },
      addressfrom:{
          city:''
        },
        addressto:{
          city:''
        },
      citiestoaply:[],
      citiestfromaply:[]
      // validSIRET: true,
    };
  },
  computed: {
    ...mapState(["currentUser"]),
    enbaleConfig() {
      return (
        (this.company.car || this.company.packet) &&
        this.company.countryFrom.length > 0 &&
        this.company.countryTo.length > 0 
      );
    },
  },
  watch: {
    // "company.siret": {
    //   handler: function (val, oldVal) {
    //     if (this.isSIRETValid(val.replace(/\s/g, ""))) {
    //       this.validSIRET = true;
    //       // this.searchCompanyInfoBySiret();
    //     } else {
    //       this.validSIRET = false;
    //     }
    //   },
    // },
  },
  methods: {
    formatPostalCode(e) {
     // e = String(e).replace(/[^\d]/g, "");
      return (this.company.address.zipCode =
        e && String(e).length > 6 ? String(e).substring(0, 6) : e);
    },
    async logOut() {
      await Auth.signOut()
        .then(() => {
          this.$notify({
            group: "default",
            title: this.$t("notifications.signOut.title"),
            text: this.$t("notifications.signOut.success"),
            type: "success",
          });
          this.$store.dispatch("resetStore");
          this.$router.replace({ name: "Home" });
        })
        .catch((err) => {
          this.$notify({
            group: "default",
            title: this.$t("notifications.signOut.title"),
            text: err.message,
            type: "error",
          });
        });
    },
    async createCompany() {
      await fetch(`${process.env.VUE_APP_API_BASE_URL}/company`, {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
        },
        method: "POST",
        body: JSON.stringify(this.company),
      })
        .then((resp) => resp.json())
        .then(async (resp) => {
          return Auth.updateUserAttributes(
            await Auth.currentAuthenticatedUser(),
            {
              "custom:companyId": resp.id,
            }
          );
        })
        .then(() => {
          this.$router.replace({ name: "agentDashboard" });
        });
    },
    async searchCompanyInfoBySiret() {
      await fetch(
        `${process.env.VUE_APP_API_BASE_URL}/companyinfo/siret/${this.company.siret}`,
        {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
          },
          method: "GET",
        }
      )
        .then((response) => response.json())
        .then((data) => {
          this.company.name = data.name;
          this.company.address.address1 = data.address1;
          this.company.address.address2 = data.address1;
          this.company.address.city = data.city;
          this.company.address.zipCode = data.zipCode;
          this.company.address.country = data.country;
        });
    },
    setCompanyAddress(address) {
      this.company.address.country = address.countryCode;
      this.company.address.address2 = address.street;
      this.company.address.city = address.city;
      this.company.address.zipCode = address.zipCode;
    },/* 
    setcountryfrom (region) {
      console.log(region);
      this.company.countryFrom = this.$t("countries").filter(country => country.regions.includes(region)).map(country => country.id);
    },
    setcountryto (region) {
      console.log(region);
      this.company.countryTo = this.$t("countries").filter(country => country.regions.includes(region)).map(country => country.id);
    }, */

    setcityfrom(addresscity) {
      if(!this.company.citiesFrom){
        this.company.citiesFrom=[];
    }
    let cityCountryObj = { city: addresscity.city, country: addresscity.countryCode };
let exists = this.company.citiesFrom.some(item => 
  item.city === cityCountryObj.city && item.country === cityCountryObj.country
);
if (!exists && addresscity.city) {
  this.company.citiesFrom.push(cityCountryObj);
  this.citiesfromaply = this.company.citiesFrom; 
  if (addresscity.countryCode && !this.company.countryFrom.includes(addresscity.countryCode)) {
      this.company.countryFrom.push(addresscity.countryCode);
    }
    
}
  },
  deletecityfrom(deletecity){
    let index = this.company.citiesFrom.findIndex(item => item.city === deletecity.city)
if (index > -1) {
  this.company.citiesFrom.splice(index,1);
  this.$set(this.company,'citiesFrom',this.company.citiesFrom);
} 
  },
  setcityto(addresscity) {
    console.log(addresscity);
    if(!this.company.citiesTo){
      this.company.citiesTo=[];
    }
    let cityCountryObj = { city: addresscity.city, country: addresscity.countryCode };
let exists = this.company.citiesTo.some(item => 
  item.city === cityCountryObj.city && item.country === cityCountryObj.country
);
if (!exists && addresscity.city) {
  this.company.citiesTo.push(cityCountryObj);
  this.citiestoaply = this.company.citiesTo; 
  if (addresscity.countryCode && !this.company.countryTo.includes(addresscity.countryCode)) {
      this.company.countryTo.push(addresscity.countryCode);
    }
}
  },
  deletecityto(deletecity){
    console.log(deletecity);
    let index = this.company.citiesTo.findIndex(item => item.city === deletecity.city)
if (index > -1) {
  this.company.citiesTo.splice(index,1);
  this.$set(this.company,'citiesTo',this.company.citiesTo);
} 
  }
    // isSIRETValid(siret) {
    //   if (siret.length != 14 || isNaN(siret)) this.validSIRET = false;
    //   else {
    //     // Donc le SIRET est un numérique à 14 chiffres
    //     // Les 9 premiers chiffres sont ceux du SIREN (ou RCS), les 4 suivants
    //     // correspondent au numéro d'établissement
    //     // et enfin le dernier chiffre est une clef de LUHN.
    //     var somme = 0;
    //     var tmp;
    //     for (var cpt = 0; cpt < siret.length; cpt++) {
    //       if (cpt % 2 == 0) {
    //         // Les positions impaires : 1er, 3è, 5è, etc...
    //         tmp = siret.charAt(cpt) * 2; // On le multiplie par 2
    //         if (tmp > 9) tmp -= 9; // Si le résultat est supérieur à 9, on lui soustrait 9
    //       } else tmp = siret.charAt(cpt);
    //       somme += parseInt(tmp);
    //     }
    //     if (somme % 10 == 0) this.validSIRET = true;
    //     // Si la somme est un multiple de 10 alors le SIRET est valide
    //     else this.validSIRET = false;
    //   }
    //   return this.validSIRET;
    // },
  },
};
</script>
<style>
.sp-input input,.sp-input2 {
  border-radius: 8px !important;
  padding: 20px 12px !important;
}
.sp-c-select .vs__dropdown-toggle{
  border-radius: 8px !important;
  background-color: white;
}
</style>
